import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { margin } from 'polished';

interface BulletTextProps {
  value: {
    title?: string;
    subtitle?: string;
    themeColor?: 'primary.main' | 'secondary.main';
    titleVariant?: any;
    subtitleVariant?: any;
    size?: string[];
  };
}
const BulletText = ({ value }: BulletTextProps) => {

  return (
    <>
      <Stack spacing={0.5}>
        <Box display={'flex'} alignItems={'center'}>
          <Box
            component="span"
            sx={{
              backgroundColor: value?.themeColor ?? 'primary.main',
              width: value?.size ?? ['14px', '15px', '16px'],
              height: value?.size ?? ['14px', '15px', '16px'],
              display: 'inline-block',
              borderRadius: '50%',
              marginRight: ['8px', '10px', '12px'],
            }}
          />
          <Typography
            variant={value?.titleVariant ?? 'body1'}
            sx={{
              marginBottom: '0px',
            }}
          >
            {value?.title}
          </Typography>
        </Box>
        <Box display={'flex'}>
          <Box pl={['8px', '10px', '12px']} ml={value?.size ?? '14px'}>
            <Typography variant={value?.subtitleVariant ?? 'body2'}>{value?.subtitle}</Typography>
          </Box>
        </Box>
      </Stack>
    </>
  );
};

export default BulletText;
